import React from 'react';
import View from '@bubble-ui/primitive-view';
import { compose, withState } from 'recompose';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Text from '@bubble-ui/primitive-text';

var SizeMarker = function SizeMarker(_ref) {
  var onTextDimensions = _ref.onTextDimensions,
      value = _ref.value,
      textDimensions = _ref.textDimensions,
      _ref$topLinesLength = _ref.topLinesLength,
      topLinesLength = _ref$topLinesLength === void 0 ? 5 : _ref$topLinesLength;
  return /*#__PURE__*/React.createElement(View, {
    style: {
      position: 'relative',
      backgroundColor: 'transparent'
    }
  }, /*#__PURE__*/React.createElement(Surface, {
    width: value,
    height: topLinesLength
  }, /*#__PURE__*/React.createElement(Shape, {
    d: "M0,0 0,".concat(topLinesLength, " 1,").concat(topLinesLength, " 1,0"),
    fill: "#FF5500"
  }), /*#__PURE__*/React.createElement(Shape, {
    d: "M0,".concat(topLinesLength - 3, " ").concat(value, ",").concat(topLinesLength - 3, " ").concat(value, ",").concat(topLinesLength - 2, " 0,").concat(topLinesLength - 2),
    fill: "#FF5500"
  }), /*#__PURE__*/React.createElement(Shape, {
    d: "M".concat(value - 1, ",0 ").concat(value - 1, ",").concat(topLinesLength, " ").concat(value, ",").concat(topLinesLength, " ").concat(value, ",0"),
    fill: "#FF5500"
  })), /*#__PURE__*/React.createElement(View, {
    onResize: onTextDimensions,
    style: {
      height: 22,
      backgroundColor: '#FF5500',
      borderRadius: 2,
      paddingLeft: 5,
      paddingRight: 5,
      position: 'absolute',
      top: 11,
      left: 0,
      transform: [{
        translateX: -(textDimensions.width - value) / 2
      }]
    }
  }, function () {
    return /*#__PURE__*/React.createElement(View, {
      style: {
        marginTop: -6
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        marginLeft: textDimensions.width / 2 - 10
      }
    }, /*#__PURE__*/React.createElement(Surface, {
      width: 10,
      height: 6
    }, /*#__PURE__*/React.createElement(Shape, {
      d: "M0,6 5,0 10,6",
      fill: "#FF5500"
    }))), /*#__PURE__*/React.createElement(Text, {
      style: {
        color: 'white',
        lineHeight: 22,
        fontFamily: 'Helvetica',
        fontSize: 12
      }
    }, value, "px"));
  }));
};

export default compose(withState('textDimensions', 'onTextDimensions', {
  width: 0
}))(SizeMarker);
//# sourceMappingURL=index.js.map